export enum SettingActionType {
  IS_INITIALISED = 'IS_INITIALISED',
  SET_PARTNER_ID = 'SET_PARTNER_ID',
  SET_TIPMODE = 'SET_TIPMODE',
  SET_PROMPT_AGENT = 'SET_PROMPT_AGENT',
  SET_EXTERNAL_REFERENCE = 'SET_EXTERNAL_REFERENCE',
  SET_CURRENT_STEPS = 'SET_CURRENT_STEPS',
  SET_SESSION_ID = 'SET_SESSION_ID',
  SET_UUID = 'SET_UUID',
  SET_APP_NAME = 'SET_APP_NAME',
  SET_LOGGER_LINK = 'SET_LOGGER_LINK',
  SET_CONFIG_LINK = 'SET_CONFIG_LINK',
  SET_ENVIRONMENT = 'SET_ENVIRONMENT',
  SET_LANGUAGE = 'SET_LANGUAGE',
  SET_CONFIRMATION_TARGET = 'SET_CONFIRMATION_TARGET',
  SET_CONFIRMATION_TYPE = 'SET_CONFIRMATION_TYPE',
  SET_REBOUND = 'SET_REBOUND',
  SET_PRECONTRACTUAL_QUOTEID = 'SET_PRECONTRACTUAL_QUOTEID',
  SET_AGENCY_INFORMATION = 'SET_AGENCY_INFORMATION',
}
